import React, { useState, useEffect } from 'react';
import styles from './RenameEditor.module.scss';
import { useTranslation } from 'react-i18next';
import CloseButton from '../CloseButton/CloseButton';
import { CustomButton } from '../Button/Button';
import { MAX_NAME_LENGTH } from '../../../common/constants/common';

const RenameEditor = ({ rename, handleRename, miniSidebar, cancelEditing, saving }) => {
  const [name, setName] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const handleNameChange = e => {
    setName(e.target.value);
  };

  useEffect(() => {
    rename.name && setName(rename.name);
  }, [rename]);

  const { t } = useTranslation();

  useEffect(() => {
    if (miniSidebar && rename.flag && isOpen) {
      cancelEditing();
      setIsOpen(false);
    }
  }, [miniSidebar, rename]);

  useEffect(() => {
    if (rename.flag) {
      setIsOpen(true);
    }
  }, [rename]);

  return (
    <>
      <div className={styles.renameContentWrapper}>
        <h2 className={styles.title}>
          {t('clip_organizer.sidebar_rename_scene_title')}
          <CloseButton onClose={cancelEditing} />
        </h2>
        <div>
          <h3 className={styles.renameTitle}>Title</h3>
          <textarea type="text" value={name} onChange={handleNameChange} maxLength={MAX_NAME_LENGTH} className={styles.textarea} />
        </div>
      </div>

      <div className={styles.footer}>
        <CustomButton
          label={t('general.editor.save_changes')}
          variant="primary"
          onClick={() => handleRename(name)}
          className={styles.sidebarButton}
          disabled={rename.name === name || !name?.trim() || saving}
        />
        <CustomButton label={t('general.cancel')} variant="secondary" onClick={cancelEditing} className={styles.sidebarButton} />
      </div>
    </>
  );
};

export default RenameEditor;
